import {
  DueOutStatusMetadata,
  DueOutStatusMetadataArgs,
  getDueOutStatusMetadata,
} from '../../assets/ts/data/dueout/dueout-status-metadata'
import useServerData from '../use-server-data'

function useDueOutStatusMetadata(fetchArgs, waitOnParentDependency = false) {
  const {
    data: dueoutStatusMetadata,
    error: dueoutStatusMetadataError,
    fetchData: fetchDueoutStatusMetdata,
    isLoading: dueoutStatusMetadataIsLoading,
  } = useServerData<DueOutStatusMetadata, DueOutStatusMetadataArgs>(
    getDueOutStatusMetadata,
    fetchArgs,
    waitOnParentDependency
  )

  return {
    dueoutStatusMetadata,
    dueoutStatusMetadataError,
    dueoutStatusMetadataIsLoading,
    fetchDueoutStatusMetdata,
  }
}

export default useDueOutStatusMetadata
